"use client";
import {
  ComponentWithChildren,
  NWONAreYouSureProvider,
} from "@nvon/react-toolbox";

const areYouSureTexts = {
  pleaseConfirm: "Bitte bestätigen Sie Ihre Eingabe.",
  areYouSure: "Sind Sie sicher?",
  confirm: "Bestätigen",
  cancel: "Abbrechen",
};

export const RVOAreYouSure: ComponentWithChildren = ({ children }) => {
  return (
    <NWONAreYouSureProvider
      defaultOptions={{
        title: areYouSureTexts.areYouSure,
        content: areYouSureTexts.pleaseConfirm,
        yesButtonProps: {
          children: areYouSureTexts.confirm,
        },
        noButtonProps: {
          children: areYouSureTexts.cancel,
        },
      }}
    >
      {children}
    </NWONAreYouSureProvider>
  );
};
